// app/javascript/controllers/quote_controller.js
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["budgetFields"]

  connect() {
    // Initialize the visibility of budget fields when the controller connects
    this.toggleBudgetFields()
  }

  toggleBudgetFields() {
    const isPredeterminedBudget = document.querySelector('input[name="event[quote_type]"]:checked')?.value === "predetermined_budget"
    
    if (isPredeterminedBudget) {
      this.budgetFieldsTarget.classList.remove("hidden")
    } else {
      this.budgetFieldsTarget.classList.add("hidden")
    }
  }
}
